import React from 'react';
/*
import {
  hf,
  ht,
  cr,
  a,
  f,
  gs,
  BoxC,
  LgnMailC,
  MsgC,
  RootC,
  GridC,
  TextC,
  _cv_31___Mz,
  useGblz,
} from 'lib';
*/
import * as BoxC from "./_ccbBoxC";
import * as TextC from "./_ccbTextC";
import * as GridC from "./_cccGridC";
import * as MsgC from "./_cccMsgC";
import * as LgnMailC from "./_ccmLgnMailC";
import * as RootC from "./_ccmRootC";
import * as f from "./_cmFTH"; // 廃止予定
import * as cr from './_cr';
import { a } from "./_csAbt";
import * as gs from "./_csGbl";
import * as _cv_31___Mz from "./_cv_31___Mz";
import * as ht from './_ht';
import * as hf from './_hf';
import * as hfDTM from './_hfDTM';

import IccvFtr from './IccvFtr';

import * as icvi18 from './icvI18___Mz';

export const N = (pz: {
  sPz: ht.dz,
}) => {

  const _gUserz = gs.useUserz();

  return (
    cr.c(RootC.N, {
      key: -10,
      abtType: 'dtpCmnz',
      bdyCz: {
        boxStlz: a(`f/n`),
        oClds: [

          cr.c(GridC.N, {
            key: -20,
            abtType: 'lgnCmnz',
            boxStlz: 
              cr.chkDvc() == 'p' ?
                undefined
              : a('f/n fd/csc'),
            lineCs: [
              {
                boxStlz: a('dw/f sc/bl7'),
                cellCs: [
                ]
              },
              {
                boxStlz: a('dw/f dh/10 f/n mb/4 sc/bl7'),
                cellCs: [
                  {
                    oClds: [
                      cr.c(TextC.N, {
                        key: -10,
                        abtType: 'lgnHdgDntz',
                        textz: {
                          pfx: `【${_gUserz.crt._20rz?._pfx ?? ''}】 施設利用予約`,
                          stlz: a('ta/c tc/lt1'),
                        },
                      }),
                    ]
                  }
                ]
              },
              {
                boxStlz: a('f/n mb/4 ph/2'),
                cellCs: [
                  {
                    oClds: [

                      cr.c(MsgC.N, {
                        key: -10,
                        abtType: 'lgn1Cmnz',
                        cz: {
                          ls: [
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '▼',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: '前画面で入力したメールアドレス「【メールアドレス】」宛に送信された確認コードを入力してください。',
                                },
                              }
                            },
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '※',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: '入力はメールの受け取りから30分以内です。30分を過ぎると、新しい確認コードが必要になりますので、ご注意ください。',
                                },
                              }
                            },
                            {
                              mkrCz: {
                                textz: {
                                  pfx: '※',
                                }
                              },
                              msgCz: {
                                textz: {
                                  pfx: 'セキュリティ強化のため、操作を行わず1時間をすぎると自動的にログアウトします。操作を再開する場合は、改めて発行した確認コードを入力する必要があります。',
                                },
                              }
                            },
                          ]
                        }
                      }),

                    ]
                  }
                ]
              },
              {
                boxStlz: a('f/n mb/2'),
                cellCs: [
                  {
                    oClds: [
                      cr.c(LgnMailC.C, {
                        key: -10,
                        sPz: pz.sPz,
                        cz: {
                          ccd: `bl7`,
                          grtCfmz: (_dz: ht.dz) => ({
                            cdn: `_10rt1100i = 10 AND (
                                 _icn = (SELECT _fst || '_1' FROM i18rs WHERE ${f.vdd()} AND i18rab100s='${pz.sPz.crt.i18rab100s}' AND i18ra4110s='${_dz.eml}')
                              OR _icn = (SELECT _fst || '_2' FROM i18rs WHERE ${f.vdd()} AND i18rab100s='${pz.sPz.crt.i18rab100s}' AND i18ra4210s='${_dz.eml}')
                              OR _icn = (SELECT _fst || '_3' FROM i18rs WHERE ${f.vdd()} AND i18rab100s='${pz.sPz.crt.i18rab100s}' AND i18ra4310s='${_dz.eml}')
                            )` 
                          }),
                          atrCfm: async (_dz: ht.dz) => {
                            //hf.l(`Iccv11a1b 132: here`);
                            if (hf.f(_dz)) {
                              const __31r_fst = _dz._10r_31r1f; 
                              const __31z = await _cv_31___Mz.load_31rDzAsync({
                                _31r_fst: __31r_fst,
                              });
                              await _gUserz.saveAsync({
                                _31rz: __31z._31rz,
                              });
                              const _i18r_fst = Number(String(_dz._icn).split('_')[0]);                              
                              const _i18z = await icvi18.loadI18rDzAsync({
                                i18r_fst: _i18r_fst,
                              });
                              await _gUserz.saveAsync({
                                i18rz: _i18z.i18rz,
                                i15rz: _i18z.i15rz,
                              })
                              await _gUserz.saveAsync({
                                usrClr: 'bl',
                              });
                              cr.moveTo({
                                pageName: 'icvHomeD10Rz',
                              });
                            }
                          }
                        }
                      })

                    ]
                  }
                ]
              },
              {
                boxStlz: a(`f/n mb/2 ph/2`),
                cellCs: [
                  {
                    oClds: [

                      cr.c(BoxC.N, {
                        key: -10,
                        oClds: [

                          cr.c(MsgC.N, {
                            key: -10,
                            abtType: 'lgn2Cmnz',
                            cz: {
                              ls: [
                                {
                                  mkrCz: {
                                    textz: {
                                      pfx: '※',
                                    }
                                  },
                                  msgCz: {
                                    textz: {
                                      pfx: '指定したメールアドレス宛に確認コードが送信されない場合は、使用しているメールアプリや通信キャリアの受信設定もご確認ください。',
                                    },
                                  }
                                },
                                {
                                  mkrCz: {
                                    textz: {
                                      pfx: '※',
                                    }
                                  },
                                  msgCz: {
                                    textz: {
                                      pfx: '正しい確認コードを入力したにも関わらずログインに失敗する場合は、システムに登録されているメールアドレスもご確認ください。',
                                    },
                                  }
                                },
                              ]
                            }
                          }),

                        ]
                      }),

                    ]
                  }
                ]
              },
              {
                boxStlz: a('f/1'),
                cellCs: [
                ]
              },
            ]
          }),

          cr.c(IccvFtr, {
            key: -30,
          })

        ],
      },
    })
  );
};
